import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { RefreshHolidayService } from 'app/core/services/refresh-holiday/refresh-holiday.service';

@Component({
  selector: 'dialog-delete-payroll-process',
  templateUrl: './dialog-delete-payroll-process.component.html',
  styleUrls: ['./dialog-delete-payroll-process.component.scss']
})
export class DialogDeletePayrollProcessComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeletePayrollProcessComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollProcessService: PayrollProcessService,
    private refreshHolidayService: RefreshHolidayService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteHoliday() {
    this.isLoading = true;
    this.payrollProcessService.deleteProcess(this.data.id).subscribe({
      next: (res) => {
        this.refreshHolidayService.emitRefresh2(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }
}

